import * as actionTypes from '../actions/actionTypes';
import axios from 'axios';

import Cookies from 'universal-cookie';

let prod = false;

export const toggleFlipCard = () => {
    return {
        type: actionTypes.TOGGLE_FLIP_CARD
    }
}

export const setUpiPin = (pin) => {
    return {
        type: actionTypes.SET_UPI_PIN,
        val: pin
    }
}

export const saveReviewDetails = (bookingObject, paymentObject) => {
    return dispatch => {
        let url = 'http://localhost:3000/payment/saveReviewDetails';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/payment/saveReviewDetails';
        }
        const headers = {
            ssoToken: localStorage.getItem('ssoToken')
        }
        dispatch(setPaymentInfoLoading());
        dispatch(setBookingDetailsLoading());
        axios.post(url, bookingObject, {headers: headers})
            .then(response => {
                const responseData = response.data;
                if(responseData.status === "success") {
                    dispatch(getPaymentInfo(paymentObject));
                }
            })
            .catch(err => {
                console.log(err);
            })
    }
}

export const saveTravellerProfile = (reviewDetails, paymentObject) => {
    return dispatch => {
        let url = 'http://localhost:3000/payment/saveTravellerProfile';
        if(prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/payment/saveTravellerProfile';
        }
        console.log(reviewDetails);
        const headers = {
            ssoToken: localStorage.getItem('ssoToken')
        }
        dispatch(setPaymentInfoLoading());
        dispatch(setBookingDetailsLoading());
        axios.post(url, reviewDetails, {headers: headers})
            .then(response => {
                const responseData = response.data;
                console.log(responseData);
                if(responseData.data.resMessage === "OK") {
                    console.log("Is success");
                    const superPnr = responseData.data.superPnr;
                    const uuid = responseData.data.uuid;

                    paymentObject.superPnr = superPnr;
                    paymentObject.uuid = uuid;
                    paymentObject.pricingId = uuid;
                    console.log(paymentObject);
                    dispatch(getPaymentInfo(paymentObject));
                }
            })
            .catch(err => {
                console.log(err);
            })
    }
}

export const setPaymentInfo = (paymentInfo) => {
    console.log(paymentInfo);
    return {
        type: actionTypes.SET_PAYMENT_INFO,
        paymentInfo: paymentInfo
    }
}

export const setPaymentInfoLoading = () => {
    return {
        type: actionTypes.SET_PAYMENT_INFO_LOADING
    }
}

export const getPaymentInfoFailed = () => {
    return {
        type: actionTypes.GET_PAYMENT_INFO_FAILED
    }
}

export const getPaymentInfo = (paymentObject) => {
    return dispatch => {
        let url = 'http://localhost:3000/payment/getCompletePaymentInfo';
        if (prod) {
            url = 'https://secure.yatra.com/quicksilvercontroller/payment/getCompletePaymentInfo';
        }
        axios.post(url, paymentObject)
        .then(response => {
            console.log(response);
            dispatch(setPaymentInfo(response.data));
        })
        .catch(err => {
            dispatch(getPaymentInfoFailed(err));
        })
    }
}

export const setBookingDetailsLoading = () => {
    return {
        type: actionTypes.SET_BOOKING_DETAILS_LOADING
    }
}

export const setPayNow = (rurl, rMap) => {
    return {
        type: actionTypes.SET_PAY_NOW,
        rurl: rurl,
        rMap: rMap
    }
}

export const payNow = (payObject) => {
function makePaymentCall (response) {
    let paymentForm = document.createElement('FORM')
    paymentForm.name = 'payment_form'
    paymentForm.method = 'POST'
    console.log('paymentjs', response.rurl)
    paymentForm.action = 'https://secure.yatra.com' + new URL(response.rurl).pathname
    let formKeys = Object.keys(response.redirectMap)
    for (let i = 0; i < formKeys.length; i++) {
    let formInput = document.createElement('INPUT')
    formInput.type = 'HIDDEN'
    formInput.name = formKeys[i]
    formInput.value = response.redirectMap[formKeys[i]]
    paymentForm.appendChild(formInput)
    }
    document.body.appendChild(paymentForm)
    paymentForm.submit()
    }
    return dispatch => {
        let url='https://secure.yatra.com/PaySwift/payNow';
        const headers = {
            ssoToken: localStorage.getItem('ssoToken')
        }
        axios.post(
            url, payObject, { headers: headers }
        )
        .then(response => {
            // if(response && response.rurl) {
            //     console.log(response.body);
            //     const result = response.body;
            //     let paymentForm = document.createElement('FORM')
            //     paymentForm.name = 'payment_form'
            //     paymentForm.method = 'POST'
            //     console.log('paymentjs', result.rurl)
            //     paymentForm.action = 'https://secure.yatra.com' + new URL(result.rurl).pathname
            //     let formKeys = Object.keys(result.redirectMap)
            //     for (let i = 0; i < formKeys.length; i++) {
            //         let formInput = document.createElement('INPUT')
            //         formInput.type = 'HIDDEN'
            //         formInput.name = formKeys[i]
            //         formInput.value = result.redirectMap[formKeys[i]]
            //         paymentForm.appendChild(formInput)
            //     }
            //     document.body.appendChild(paymentForm)
            //     paymentForm.submit();
            // } else {
            //     console.log("Error message");
            //     // if(response.body && Object.keys(response.body.redirectMap)) {
            //     //     self.paymentErrorMessage = response.body.redirectMap.errMsg || "Oops, we seem to have temporary hiccup. We apologise for the inconvenience caused and request you to try again."
            //     //     self.showPaymentDialog=true
            //     // }
            //     // else {
            //     //     self.navigateToSrp()
            //     // }
            // }
            if(response.data.success) {
                dispatch(setPayNow(response.data.rurl, response.data.redirectMap))
            }
        })
        .catch(err => {
            console.log(err);
        })
    }
}

export const getPaymentResponse = (paymentParams, isInt) => {
    const tenant = isInt ? 'int2' : 'dom2';
    console.log("Inside getPaymentResponse reducer");

    return dispatch => {
        axios.get(
            `https://secure.yatra.com/air-pay-book-service/${tenant}/confirm/getResponseFromPaymentPortal`, paymentParams
        )
        .then(response => {
            console.log("Inside getPaymentResponse response");
            console.log(response);
        })
        .catch(err => {
            console.log(err);
        })
    }
}

export const setCardNumberValidation = () => {
    return {
        type: actionTypes.SET_CARD_NUMBER_VALIDATION
    }
}

export const setCardNameValidation = () => {
    return {
        type: actionTypes.SET_CARD_NAME_VALIDATION
    }
}

export const setCVVValidation = () => {
    return {
        type: actionTypes.SET_CVV_VAIDATION
    }
}

export const setAmountDetails = (data) => {
    return {
        type: actionTypes.SET_AMOUNT_DETAILS,
        val: data
    }
}

export const setPaypalOption = (option) => {
    return {
        type: actionTypes.SET_PAYPAL_OPTION,
        val: option
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/payments.js